import { z } from 'zod'

// Admin 本地的通用回执 schema；业务响应 schema 与 Gateway 共用 @novelaide/shared-types。
export const OkResponseSchema = z.object({ ok: z.literal(true) })
export const VoidResponseSchema = z.undefined()
